// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__31FrP","Footer__Icon":"Footer_Footer__Icon__2ATOy"};